export default {
    '0': {
        'type': 'None'
    },
    '1': {
        'type': 'Page'
    },
    '2': {
        'type': 'Block'
    },
    '3': {
        'type': 'Media'
    }
};


// WEBPACK FOOTER //
// ./src/core/admin/config/contentDefinitionTypes.js